module.exports = __webpack_public_path__ + "static/media/bg-no-coin-head.7b4e047d.png";